import React, {Component} from 'react';
import lang from '../../Lang/lang.json';
import Icons from '../../../Containers/Icons';
import BackupDBFiles from './BackupDBFiles';
import BackupImgSel from './BackupImgSel';

class BackupImg extends Component {
  constructor(){
    super();
    this.dbInput= React.createRef();
    this.state = {
      dbfiles: false,
      imgfoldersY: "",
      imgfoldersM: "",
      year: "",
      month: "",
      delfile: ""
    }
  }
  componentWillMount() {
    this.readDBFiles();
  }
  selectDelete = (file) => {
    this.setState({delfile: file})
    this.props.funct('ImgfileBk');
  }
  closeDel = () => {
    this.props.funct('ImgfileBk');
  }
  readDBFiles = (year = false) => {
    let bodycall;
    if (!year) {
      bodycall = {
        type: "backupImg",
        post: {
          action: "read"
        },
        tkn: this.props.tkn
      }
    } else {
      bodycall = {
        type: "backupImg",
        post: {
          action: "read",
          year: year
        },
        tkn: this.props.tkn
      }
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodycall)
    }).then(res => res.json()).then(res => {
      if (res.imgM) {
        if (res.tkn === false) {
          this.props.logOut();
        } else {
          this.setState({imgfoldersM: res.imgM})
        }
      } else {
        if (res.tkn === false) {
          this.props.logOut();
        } else {
          this.setState({dbfiles: res.bkup, imgfoldersY: res.imgs})
        }
      }
    })
  }
  getYearAndMonth = (time) => (e) => {
    if (time === "year") {
      this.setState({[time]: e.target.value});
      this.readDBFiles(e.target.value);
    } else {
      this.setState({[time]: e.target.value});
    }
  }
  deleteOriginal = () => {
    console.log(this.state)
    if (this.state.year && this.state.month) {
      let bodycall = {
        type: "backupImg",
        post: {
          action: "delete",
          year: this.state.year,
          month: this.state.month
        },
        tkn: this.props.tkn
      }
      fetch(`${this.props.url}api.php`, {
        method: 'post',
        headers: {'Content-type': 'application/json'},
        body: JSON.stringify(bodycall)
      }).then(res => res.json()).then(res => {
        if (res) {
          this.props.msg('ok', 'e30');
        } else {
          this.props.msg('error', 'e31');
        }
      })
    } else {
      console.log("you didnt select a year and month")
    }
  }
  createImgBkup = () => {
    console.log(this.state)
    if (this.state.year && this.state.month) {
      let bodycall = {
        type: "backupImg",
        post: {
          action: "create",
          year: this.state.year,
          month: this.state.month
        },
        tkn: this.props.tkn
      }
      fetch(`${this.props.url}api.php`, {
        method: 'post',
        headers: {'Content-type': 'application/json'},
        body: JSON.stringify(bodycall)
      }).then(res => res.json()).then(res => {
        if (res) {
          console.log(res);
          this.readDBFiles();
          this.props.msg('ok', 'e22');
        } else {
          this.props.msg('error', 'e26');
        }

      })
    } else {
      console.log("you didnt select a year and month")
    }
  }
  deleteZipFiles = () => {
    let bodycall = {
      type: "backupImg",
      post: {
        action: "deletezip",
        file: this.state.delfile
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodycall)
    }).then(res => res.json()).then(res => {
      if (res) {
        this.props.msg('ok', 'e23');
        this.readDBFiles();
        this.closeDel();
      } else {
        this.props.msg('error', 'e29');
        this.closeDel();
      }
    })
  }
  uploadDBFile = () => {
    this.dbInput.current.click();
  }
  selectFileToUpload = (event) => {
    let file = event.target.files[0];
    const data = new FormData();
    data.append("dbFile", file);
    console.log(file);
    data.append("tkn", this.props.tkn);
    data.append("screen", "addZipFile");
    fetch(`${this.props.url}api.php`, {
      method: "POST",
      body: data
    }).then((res) => (res.json()).then((res) => {
      if (res) {
        this.props.msg('ok', 'e24');
        this.readDBFiles();
      } else {
        this.props.msg('error', 'e27');
      }
    }));
  }
  restoreBackupZip = (file) => {
    let bodycall = {
      type: "backupImg",
      post: {
        action: "restore",
        file: file
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodycall)
    }).then(res => res.json()).then(res => {
      if (res) {
        console.log(res);
        this.props.msg('ok', 'e20');
        this.readDBFiles();
      } else {
        this.props.msg('error', 'e28');
      }
    })
  }
  render () {
    let {language, url} = this.props;
    let openMod;
    this.props.openMod
    ? openMod = "open"
    : openMod = "closed"
    return(
      <div id="backup_img">
        <div className="backup_files">
          <div className="tab_titles">
            <span className="filetitle">{lang.BackupDB.title[language]}</span>
            <span>{lang.BackupDB.download[language]}</span>
            <span>{lang.BackupDB.erase[language]}</span>
            <span>{lang.BackupDB.load[language]}</span>
          </div>
          <BackupDBFiles 
            type="img"
            openMod={this.selectDelete} 
            files={this.state.dbfiles} 
            url={url}
            restore={this.restoreBackupZip}/>
          <div className="backup_actions">
            <div className="outline-butn gray" onClick={() => this.uploadDBFile()}>
              {lang.BackupDB.upload[language]}
            </div>
            <input ref={this.dbInput} type="file" onChange={this.selectFileToUpload}/>
          </div>
        </div>
        <div className="backup_note">
          <div>
            <h2>{lang.BackupDB.note_title[language]}</h2>
            <p>{lang.BackupDB.note[language]}</p>
            <p>{lang.BackupDB.note2[language]}</p>
          </div>
          <BackupImgSel 
            years={this.state.imgfoldersY}
            months={this.state.imgfoldersM} 
            getDate={this.getYearAndMonth}
            deleteOriginal={this.deleteOriginal}
            createImgBkup={this.createImgBkup}
            language={language}/>
        </div>
        <div className={`modal delete ${openMod}`}>
          <span className="formButton ok white" onClick={() => this.deleteZipFiles()}>
            <Icons name="ok"/>
          </span>
          <span className="info">
            <h3>{lang.UsrCnf.delete[this.props.language]}</h3>
            <p>{lang.BackupDB.deleteinfo[this.props.language]}</p>
          </span>
          <span 
            className="formButton close white" 
            onClick={() => this.closeDel()}>
            <Icons name="close"/>
          </span>
        </div>
      </div>
    )
  }
}
export default BackupImg;


// WEBPACK FOOTER //
// ./src/Components/Admin/Backup/BackupImg.js